import { Preload, SoftShadows } from "@react-three/drei";
import { Canvas, useThree } from "@react-three/fiber";
import { Perf } from "r3f-perf";
import { ComponentType, RefObject, Suspense, useRef } from "react";
import { DeviceProps } from "@components/Root";

export default function AppCanvas({
    Component,
    eventSource,
    width,
    height,
    ...props
}: {
    Component: ComponentType<DeviceProps>;
    eventSource: RefObject<HTMLDivElement>;
    width: number;
    height: number;
} & DeviceProps) {
    const canvas = useRef<HTMLCanvasElement>(null);

    if (!Component) return <></>;
    return (
        <Canvas ref={canvas}
            shadows
            flat
            dpr={[1, 2]}
            camera={{ fov: 70 }}
            eventSource={eventSource.current!}
            style={{ position: "fixed", width: `${width}px`, height: `${height}px`, left: "0px", top: "0px", pointerEvents: "none", zIndex: 4 }}
            onCreated={(state) => {
                state.setEvents({
                    compute: (event, state) => {
                        state.pointer.set(event.pageX / state.size.width * 2 - 1, -event.pageY / state.size.height * 2 + 1);
                        state.raycaster.setFromCamera(state.pointer, state.camera);
                    }
                });
            }}
        >
            <OptimizeShaders />
            <Suspense fallback={null}>
                <SoftShadows size={25} samples={10} focus={0} />
                <Component {...props} />
                {process.env.NODE_ENV === "development" && <Perf position="bottom-left" deepAnalyze overClock />}
            </Suspense>
            <Preload all />
        </Canvas>
    );
}

function OptimizeShaders() {
    const gl = useThree(state => state.gl);
    gl.debug.checkShaderErrors = process.env.NODE_ENV === "development";
    return (<></>);
}